import { Component, ViewChild, ElementRef } from '@angular/core';
import * as registrationStrings from "../stringFiles/registration.json";
import * as loginStringsDetails from "../stringFiles/newLogin.json";
import { SchoolDetailsService } from "../school-details/school-details.service";
import { firstValueFrom } from "rxjs";
import { Router } from '@angular/router';
import { commonFunctionService } from "../utils/commonFunctions"
import { SchoolRegistrationUnderVerificationService } from './school-registration-under-verification.service';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;
declare var customToastr: any;

@Component({
  selector: 'app-school-registration-under-verification',
  templateUrl: './school-registration-under-verification.component.html',
  styleUrl: './school-registration-under-verification.component.css',
  providers: [SchoolDetailsService, SchoolRegistrationUnderVerificationService]
})

export class SchoolRegistrationUnderVerificationComponent {

  @ViewChild('fileInput', { static: false }) fileInput: ElementRef<HTMLInputElement>;
  strings: any;
  loader: boolean = false;
  isVerified: boolean = false;
  showGradientCard: boolean = true;
  schoolAddress: any;
  schoolPhoneNumber: any;
  schoolEmailId: any;
  schoolName: any;
  schoolImage: any;
  countryCode: any;
  loginStrings: any;
  getAuthToken: any;
  currentQuestionIndex: number = 0;
  questionId: any;
  answer: string = "";
  questionArrayList: any[] = [];
  isPrevBtnClicked: boolean = false;
  isNextBtnClicked: boolean = false;

  constructor(private router: Router, private schoolDetailsService: SchoolDetailsService, private commonFunction: commonFunctionService, private schoolRegistrationUnderVerificationService: SchoolRegistrationUnderVerificationService, private translate: TranslateService) {
    this.initScript()
    this.strings = registrationStrings;
    this.loginStrings = loginStringsDetails;
    const tokenCookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith('usertoken='));
    let tokenValue = tokenCookie ? tokenCookie.split('=')[1] : null;
    this.getAuthToken = tokenValue;
    const schoolAddress = document.cookie.split(';').find(cookie => cookie.trim().startsWith('schoolAddress='));
    let schoolAddressDetails = schoolAddress ? schoolAddress.split('=')[1] : null;
    this.schoolAddress = schoolAddressDetails;
    const phoneNumber = document.cookie.split(';').find(cookie => cookie.trim().startsWith('phoneNumber='));
    let phoneNumberDetails = phoneNumber ? phoneNumber.split('=')[1] : null;
    this.schoolPhoneNumber = phoneNumberDetails;
    const schoolEmailId = document.cookie.split(';').find(cookie => cookie.trim().startsWith('schoolEmailId='));
    let schoolEmailIdDetails = schoolEmailId ? schoolEmailId.split('=')[1] : null;
    this.schoolEmailId = schoolEmailIdDetails;
    const schoolName = document.cookie.split(';').find(cookie => cookie.trim().startsWith('schoolName='));
    let schoolNameDetails = schoolName ? schoolName.split('=')[1] : null;
    this.schoolName = schoolNameDetails;
    const schoolImage = document.cookie.split(';').find(cookie => cookie.trim().startsWith('schoolImage='));
    let schoolImageDetails = schoolImage ? schoolImage.split('=')[1] : null;
    this.schoolImage = schoolImageDetails;
    const countryCode = document.cookie.split(';').find(cookie => cookie.trim().startsWith('countryCode='));
    let countryCodeDetails = countryCode ? countryCode.split('=')[1] : null;
    this.countryCode = countryCodeDetails;
    this.addInstituteInformationDetails()
    this.getRegistrationQuestionnaire()
    this.checkSession()
  }

  nextQuestion(): void {
    const currentQuestion = this.questionArrayList[this.currentQuestionIndex];
    const oldAnswer = currentQuestion.answer;
    if ((this.answer.trim() && this.answer.trim() !== oldAnswer) || (oldAnswer && !this.answer.trim())) {
      this.isNextBtnClicked = true;
      this.schoolQuestionnaireAnswer().then(() => {
        currentQuestion.answer = this.answer.trim();
        if (this.currentQuestionIndex < this.questionArrayList.length - 1) {
          this.currentQuestionIndex++;
          this.updateAnswer();
        } else {
          $('#questionArray').modal('hide');
          this.questionId = "";
          this.answer = "";
        }
      }).finally(() => {
        this.isNextBtnClicked = false;
      });
    } else {
      if (this.currentQuestionIndex < this.questionArrayList.length - 1) {
        this.currentQuestionIndex++;
        this.updateAnswer();
      } else {
        $('#questionArray').modal('hide');
        this.questionId = "";
        this.answer = "";
      }
    }
  }

  prevQuestion(): void {
    const currentQuestion = this.questionArrayList[this.currentQuestionIndex];
    const oldAnswer = currentQuestion.answer;
    if ((this.answer.trim() && this.answer.trim() !== oldAnswer) || (oldAnswer && !this.answer.trim())) {
      this.isPrevBtnClicked = true;
      this.schoolQuestionnaireAnswer().then(() => {
        currentQuestion.answer = this.answer.trim();
        if (this.currentQuestionIndex > 0) {
          this.currentQuestionIndex--;
          this.updateAnswer();
        }
      }).finally(() => {
        this.isPrevBtnClicked = false;
      });
    } else {
      if (this.currentQuestionIndex > 0) {
        this.currentQuestionIndex--;
        this.updateAnswer();
      }
    }
  }

  handleContinue() {
    this.updateAnswer()
  }
  underVerification() {
    this.isVerified = true;
  }

  notInterested() {
    this.showGradientCard = false;
  }

  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const imgElement = document.querySelector('.placeholder-image') as HTMLImageElement;
        imgElement.src = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  initScript() {
    $(".after").empty();
    $("#device-breakpoints").remove();
    $(".after").append(
      "<script>function customToastr(message,type){toastr.options.hideDuration = 0;toastr.clear();" +
      "toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;" +
      "toastr.options.positionClass = 'toast-top-right';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;" +
      "toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = 'swing';" +
      "toastr.options.hideEasing = 'swing';toastr.options.showMethod = 'slideDown';toastr.options.hideMethod = 'slideUp';" +
      "toastr[type](message, '');return 0;} </" +
      "script>"
    );
  }

  async addInstituteInformationDetails() {
    try {
      this.loader = true;
      const body = {
      }
      const response = await firstValueFrom(
        this.schoolDetailsService.addInstituteInformationDetailsApi(body, this.getAuthToken)
      );
      const responseDetails = response as any;
      if (responseDetails.status) {
        if (
          responseDetails.body &&
          responseDetails.body.schoolInfo &&
          responseDetails.body.schoolInfo.isSchoolVerified
        ) {
          const schoolInfoDetails = responseDetails.body.schoolInfo.schoolInfo;
          const hostName = window.location.hostname;
          const urlHost = hostName.split(".")[1];
          if (urlHost === this.loginStrings.localhost) {
            this.commonFunction.setCookieLocal(this.loginStrings.loginMode, this.loginStrings.WEB_ADMIN, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.usertoken, this.getAuthToken, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolinfo, schoolInfoDetails.schoolId, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.adminType, schoolInfoDetails.adminType, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.feesModuleSettings, JSON.stringify(schoolInfoDetails.feesModuleSettings), 7);
            this.commonFunction.setCookieLocal(this.loginStrings.currency, schoolInfoDetails.currencyType, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.isFranchise, schoolInfoDetails.isFranchise == 0 ? "0" : schoolInfoDetails.isFranchise, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.fkFranchiseId, schoolInfoDetails.fkFranchiseId ? schoolInfoDetails.fkFranchiseId : "null", 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolDomain, schoolInfoDetails.SchoolDomain, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolVerification, null, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.countryCode, schoolInfoDetails.countryCode, 7);
            const d = {};
            const arr = schoolInfoDetails.adminPermissions;
            arr.forEach(item => {
              d[item.BluewingsFeatureName] = item.ActiveStatus || item.AdminAccessStatus;
            });
            this.commonFunction.setCookieLocal(this.loginStrings.adminPermissionlist, JSON.stringify(d), 7);
          } else {
            this.commonFunction.setCookie(this.loginStrings.loginMode, this.loginStrings.WEB_ADMIN, 7);
            this.commonFunction.setCookie(this.loginStrings.usertoken, this.getAuthToken, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolinfo, schoolInfoDetails.schoolId, 7);
            this.commonFunction.setCookie(this.loginStrings.adminType, schoolInfoDetails.adminType, 7);
            this.commonFunction.setCookie(this.loginStrings.feesModuleSettings, JSON.stringify(schoolInfoDetails.feesModuleSettings), 7);
            this.commonFunction.setCookie(this.loginStrings.currency, schoolInfoDetails.currencyType, 7);
            this.commonFunction.setCookie(this.loginStrings.isFranchise, schoolInfoDetails.isFranchise == 0 ? "0" : schoolInfoDetails.isFranchise, 7);
            this.commonFunction.setCookie(this.loginStrings.fkFranchiseId, schoolInfoDetails.fkFranchiseId, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolDomain, schoolInfoDetails.SchoolDomain, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolVerification, null, 7);
            this.commonFunction.setCookie(this.loginStrings.countryCode, schoolInfoDetails.countryCode, 7);
            const d = {};
            const arr = schoolInfoDetails.adminPermissions;
            arr.forEach(item => {
              d[item.BluewingsFeatureName] = item.ActiveStatus || item.AdminAccessStatus;
            });
            this.commonFunction.setCookie(this.loginStrings.adminPermissionlist, JSON.stringify(d), 7);
          }
          customToastr(responseDetails.body.message, this.loginStrings.success);
          if (schoolInfoDetails.isFranchise == 1) {
            this.router.navigate(["/franchise/dashboard"]);
          } else {
            this.router.navigate(["/dashboard"]);
          }
        }
      } else {
        customToastr(responseDetails.message, this.strings.errorCode);
      }
      this.loader = false;
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'))
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
        this.strings.errorCode
      );
      this.loader = false;
      return;
    }
  }

  async getRegistrationQuestionnaire() {
    try {
      const response = await firstValueFrom(this.schoolRegistrationUnderVerificationService.getRegistrationQuestionnaireApi(this.getAuthToken));
      const responseDetails = response as any;
      if (responseDetails.status) {
        if (
          responseDetails.body && responseDetails.body.length > 0
        ) {
          this.questionArrayList = responseDetails.body;
        }
      } else {
        customToastr(responseDetails.message, this.strings.errorCode);
      }
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'))
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
        this.strings.errorCode
      );
      return;
    }
  }
  async schoolQuestionnaireAnswer() {
    try {
      this.loader = true;
      const body = {
        questionId: this.questionId,
        answer: this.answer.trim(),
        lang: "en"
      }
      const response = await firstValueFrom(this.schoolRegistrationUnderVerificationService.schoolQuestionnaireAnswerApi(this.getAuthToken, body));
      const responseDetails = response as any;
      if (responseDetails.status) {
        this.getRegistrationQuestionnaire()
        customToastr(responseDetails.body.message, this.strings.successCode);
      } else {
        customToastr(responseDetails.message, this.strings.errorCode);
      }
      this.loader = false;
      this.isNextBtnClicked = false;
      this.isPrevBtnClicked = false;
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'))
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
        this.strings.errorCode
      );
      this.loader = false;
      this.isNextBtnClicked = false;
      this.isPrevBtnClicked = false;
      return;
    }
  }

  handleSkip() {
    this.questionId = "";
    this.answer = "";
  }

  updateAnswer(): void {
    const currentQuestion = this.questionArrayList[this.currentQuestionIndex];
    this.questionId = currentQuestion.pkQuestionId;
    this.answer = currentQuestion.answer || "";
  }

  checkSession() {
    const tokenCookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.usertoken + this.loginStrings.equalTo));
    let tokenValue = tokenCookie ? tokenCookie.split('=')[1] : null;
    if (tokenValue) {
      const isFranchiseValue = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.isFranchise + this.loginStrings.equalTo));
      let isFranchise = isFranchiseValue ? isFranchiseValue.split('=')[1] : null;
      const schoolVerification = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.schoolVerification + this.loginStrings.equalTo));
      let schoolVerificationValue = schoolVerification ? schoolVerification.split('=')[1] : null;
      if (schoolVerificationValue && schoolVerificationValue == this.loginStrings.step1) {
        this.router.navigate(["/institute-onboard/step/1"]);
      } else if (schoolVerificationValue && schoolVerificationValue === this.loginStrings.underVerification) {
        this.router.navigate(["/institute-under-verification"]);
      }
      else {
        if (isFranchise == "1") {
          this.router.navigate(["/franchise/dashboard"]);
        } else {
          this.router.navigate(["/dashboard"]);
        }
      }
    } else {
      this.router.navigate(["/login"]);
    }
  }
}